import { render } from "./SaveWorkWeek.vue?vue&type=template&id=0c63f5f0&scoped=true"
import script from "./SaveWorkWeek.vue?vue&type=script&lang=js"
export * from "./SaveWorkWeek.vue?vue&type=script&lang=js"

import "./work-shift.scss?vue&type=style&index=0&id=0c63f5f0&lang=scss&scoped=true"

import exportComponent from "/home/paperspace/thehrway-basic/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c63f5f0"]])

export default __exports__